<ion-header>
  <ion-toolbar>
    <ion-title>Payment</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="payment-container">
    <div *ngIf="isLoading" class="loader-container">
      <ion-spinner></ion-spinner>
      <p>Loading payment gateway...</p>
    </div>

    <div *ngIf="errorMessage" class="error-container">
      <ion-icon name="alert-circle"></ion-icon>
      <p>{{ errorMessage }}</p>
      <ion-button (click)="closeModal()">Close</ion-button>
    </div>

    <iframe
      *ngIf="!errorMessage"
      [src]="safePaymentUrl"
      class="payment-iframe"
      (load)="onIframeLoad()"
      (error)="onIframeError()"
      title="Payment Gateway">
    </iframe>
  </div>
</ion-content>
